import styles from './Strikeout.module.css';

type IntrinsicDelProps = JSX.IntrinsicElements['del'];

/**
 * Place a strikethrough over text, rendered as `del` HTML element.
 *
 * @see https://corgi-x.tfd.engineering/components/strikeout
 */
export function Strikeout({ children, ...props }: IntrinsicDelProps) {
  return (
    <del className={styles.strikeout} {...props}>
      {children}
    </del>
  );
}
